const server = 'http://www.gzyueyun.com';

const imgRoot = '/yueyun';

const root = server + '/yueyunapi';

const qs = require('qs');

// 定义导航类型
// 首页导航
const items = [
    { path: '/', title: "首页" },
    // { path: '#second', title: "解决方案" },
    // { path: '#third', title: "展示案例" },
    // { path: '#fourth', title: "入驻流程" },
    { path: '/download', title: "操作手册" },
    { path: '/expense', title: "费用说明" },
    { path: 'https://geju.gzyueyun.com:8443/xhpc/login.html', title: "协会管理系统" }
];

// 详情页导航
const NavItem = [
    { path: '/', title: "首页", id: '1' },
    { path: '/index/CaseAll', title: "案例展示", id: '2' },
    { path: '/index/about', title: "关于我们", id: '3' },
];


// aip
const getCategory = root + '/mainController/getCategory'; // 获取成功案例的类型列表

const getCaseList = root + '/mainController/getNewCaseList'; // 获取成功案例列表

const getCaseDetail = root + '/mainController/getNewCase'; // 获取成功案例列详情

const getSchemeDetail = root + '/mainController/getSolution'; // 获取解决方案详情

const getOfficialController = 'https://geju.gzyueyun.com/xhapi/xhapi/OfficialController/note.hn'; //提交留言

export default {
    items, //首页
    NavItem, //详情页
    server, //域名地址
    imgRoot, //图片链接拼接
    root, //api拼接
    qs, //序列化数据
    getCategory, // 获取成功案例的类型列表
    getCaseList, // 获取成功案例列表
    getCaseDetail, // 获取成功案例列详情
    getSchemeDetail, // 获取解决方案详情
    getOfficialController, //提交留言
}